import { HubConnectionState } from '@microsoft/signalr'

import { GetterTree } from 'vuex'

import { RootState } from './state'

const getters: GetterTree<RootState, RootState> = {
  /**
   * Checks if the WebSocket is Connected.
   */
  isWebSocketConnected (state): boolean {
    return state.webSocketStatus === HubConnectionState.Connected
  }
}

export default getters
